// extracted by mini-css-extract-plugin
module.exports = {"task_form":"TaskForm_task_form__A8dsY","title":"TaskForm_title__2NQiF","hint":"TaskForm_hint__Kjm19","group":"TaskForm_group__2bU5d","selected":"TaskForm_selected__3jS1p"};